import { useDocumentPreviewTracked } from "presentation/store/DocumentPreview/DocumentPreviewProvider";
import { memo, useMemo } from "react";
import { SliderPanel } from "veronica-ui-component/dist/component/core";
import AddRemoveRejectApproveModal from "../EditModal/AddRemoveRejectApproveModal";
import DocumentPreviewTablePanel from "../Table/DocumentPreviewTablePanel";
import DocumentPreviewAdjCntrPanel from "./DocumentPreviewAdjCntrPanel";
import DocumentPreviewEditPanel from "./DocumentPreviewEditPanel";

const DocumentPreviewRightPanel = () => {
    const [documentPreviewState] = useDocumentPreviewTracked();
    const { isShowEditPanel, isShowAdjCntrPanel } = documentPreviewState;

    const memoDocumentPreviewTable = useMemo(() => {
        return <DocumentPreviewTablePanel />
    }, [])
    const memoDocumentPreviewEditPanel = useMemo(() => {
        return <DocumentPreviewEditPanel />
    }, [])

    const memoDocumentPreviewAdjCntrPanel = useMemo(() => {
        return <DocumentPreviewAdjCntrPanel />
    }, [])

    return <>
        <div className={`main-comp-wrapper${(isShowEditPanel || isShowAdjCntrPanel) ? '' : ' im-hide-side-form-draggable'}`}>

            <SliderPanel
                isOpen={true}
                draggable={true}
                leftSectionWidth={isShowEditPanel ? "70%" : isShowAdjCntrPanel ? "30%" : "100%"}
                rightSectionWidth={isShowEditPanel ? "30%" : isShowAdjCntrPanel ? "70%" : "0%"}
                leftChildren={memoDocumentPreviewTable}
                rightChildren={isShowEditPanel ? memoDocumentPreviewEditPanel : isShowAdjCntrPanel ? memoDocumentPreviewAdjCntrPanel : <></>}
            />
            <div className='im-charge-data-search-confirm-modal-container'>
                {<AddRemoveRejectApproveModal />}
            </div>
        </div>
    </>
}

export default memo(DocumentPreviewRightPanel);